/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { getAdHistories } from '../../apis/admin/adManagers';
import { getParams } from '../../utils/params';
import { ControlTable } from '../Table';
import Filters from '../Filters';

const AdHistories = (props) => {

  const [fields] = useState([
    { title: "광고명", key: "content.title" },
    { title: "직원명", key: "employee.name" },
    { title: "접근 시간", key: "clickTime", type: "datetime" },
  ]);
  const [filters] = useState([
    {
      title: "광고명 검색",
      type: "input",
      placeholder: "광고명 입력",
      key: "search.title"
    },
    {
      title: "직원 검색",
      type: "input",
      placeholder: "직원명 입력",
      key: "search.employeeName"
    },
  ]);
  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    limit: 10,
    offset: 0,
    order: [{ clickTime: "desc" }]
  });

  const submit = (form) => {
    getAdHistories(getParams(form))
      .then(res => {
        const { rows, count } = res.data;
        setList(rows);
        setTotal(count);
      }).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideControlHeader
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={false}
      />
    </>
  );
};

export default AdHistories;